export default __webpack_public_path__ + "static/media/placeholder.fa60b5db.svg";